<template lang="pug">
head-meta(
  title-page="Музей «Шоколадный Выборг» находится в центре Выборга",
  description="Ждём вас каждый день с 11 до 19 по будням и с 11 до 20 по выходным по адресу: Ул. Штурма 1А (бывший ресторан \"Русский двор\"). Вход свободный!"
)
the-contacts
index-slide(class-mod="contacts")
home-video(class-mod="contacts")
schema-org-contacts
</template>

<script>
import TheContacts from '../components/contacts/TheContacts'
import HomeVideo from '../components/HomeVideo'
import IndexSlide from '../components/IndexSlide'
import HeadMeta from '../components/_layout/HeadMeta'
import SchemaOrgContacts from '../components/_layout/SchemaOrgContacts'

export default {
  name: 'ContactsPage',
  components: { SchemaOrgContacts, HeadMeta, IndexSlide, HomeVideo, TheContacts }
}
</script>
